{
  "id": "hob-aa-waraq",
  "slug": "hob-aa-waraq",
  "title": "حب ع ورق",
  "title_en": "Love on Paper",
  "title_fr": "Amour sur papier",
  "original_title": "Hob Aa Waraq",
  "description": "عندما يقص ملياردير قاسي أجنحة أحلامها الأكاديمية، تبرم بائعة ورد طموحة اتفاقاً مؤقتاً مع عدوها اللدود. وبينما تتلاشى منطقية عالم الأعمال أمام جاذبية جارفة، يهدد ماض غير منكشف بتمزيق حكاية حب لم تكتب إلا على الورق.",
  "description_en": "When a ruthless billionaire clips the wings of her academic dreams, an ambitious flower seller makes a temporary agreement with her arch-enemy. As the logic of the business world fades in the face of an overwhelming attraction, an unrevealed past threatens to tear apart a love story written only on paper.",
  "description_fr": "Lorsqu'un milliardaire impitoyable coupe les ailes de ses rêves académiques, une fleuriste ambitieuse conclut un accord temporaire avec son ennemi juré. Alors que la logique du monde des affaires s'estompe face à une attirance irrésistible, un passé inavoué menace de déchirer une histoire d'amour qui n'était écrite que sur le papier.",
  "year": 2026,
  "first_air_date": "",
  "last_air_date": "",
  "status": "مستمر",
  "status_en": "Ongoing",
  "status_fr": "En cours",
  "genres": [
    "Comedy",
    "Social",
    "Romance"
  ],
  "genres_ar": [
    "كوميديا",
    "اجتماعي",
    "رومانسي"
  ],
  "genres_fr": [
    "Comédie",
    "Social",
    "Romance"
  ],
  "country": "MA",
  "rating": 8.0,
  "poster": "https://github.com/elhizazi1/filerawanui/raw/refs/heads/main/Haw/poster-haw.webp",
  "backdrop": "https://github.com/elhizazi1/filerawanui/raw/refs/heads/main/Haw/backdrop-haw.webp",
  "trailer_url": "https://www.youtube.com/watch?v=y19zGkPApQE",
  "tags": [
    "حب ع ورق",
    "مسلسل عربي",
    "أنس طيارة",
    "هيا مرعشلي",
    "كوميديا",
    "رومانسي"
  ],
  "is_trending": true,
  "is_new": true,
  "seasons_count": 1,
  "article": [
    {
      "id": "h-1",
      "type": "heading",
      "level": 2,
      "text": "قصة مسلسل 'حب ع ورق': عندما يتحول الصراع إلى جاذبية جارفة",
      "text_en": "The Story of 'Hob Aa Waraq': When Conflict Turns into an Overwhelming Attraction",
      "text_fr": "L'histoire de 'Amour sur papier' : Quand le conflit se transforme en une attirance irrésistible"
    },
    {
      "id": "p-1",
      "type": "paragraph",
      "dropCap": true,
      "html": "يقدم مسلسل 'حب ع ورق' دراما اجتماعية وكوميدية مشوقة، حيث تتقاطع طرق ملياردير قاسي مع بائعة ورد طموحة. بعد أن يدمر أحلامها الأكاديمية، يجدان نفسيهما مضطرين لإبرام اتفاق مؤقت يجمعهما كأعداء، لكن سحر عالم الأعمال والمنطق يتلاشى تدريجياً.",
      "html_en": "The series delivers an engaging blend of social drama and comedy, where the paths of a ruthless billionaire and an ambitious flower seller cross. After he shatters her academic dreams, they find themselves forced into a temporary pact as enemies, but the cold logic of the business world gradually fades away.",
      "html_fr": "La série offre un mélange captivant de drame social et de comédie, où les chemins d'un milliardaire impitoyable et d'une fleuriste ambitieuse se croisent. Après qu'il ait brisé ses rêves académiques, ils se retrouvent contraints de conclure un pacte temporaire en tant qu'ennemis, mais la froide logique du monde des affaires s'estompe peu à peu."
    },
    {
      "id": "p-2",
      "type": "paragraph",
      "html": "تتطور الأحداث بشكل مثير عندما تتحول هذه العداوة إلى جاذبية لا يمكن السيطرة عليها، إلا أن هناك ماضياً غامضاً يهدد بتدمير هذه العلاقة التي لم تُبنَ في البداية إلا كحبر على ورق.",
      "html_en": "The plot thickens thrillingly as this animosity turns into an uncontrollable attraction. However, a mysterious past threatens to destroy this relationship, which was initially built as nothing more than ink on paper.",
      "html_fr": "L'intrigue s'épaissit de manière palpitante lorsque cette animosité se transforme en une attirance incontrôlable. Cependant, un passé mystérieux menace de détruire cette relation, qui n'était initialement construite que comme de l'encre sur du papier."
    },
    {
      "id": "h-2",
      "type": "heading",
      "level": 3,
      "text": "طاقم العمل وأبرز المميزات",
      "text_en": "Cast and Key Highlights",
      "text_fr": "Distribution et points forts"
    },
    {
      "id": "l-1",
      "type": "list",
      "ordered": false,
      "items": [
        "بطولة نخبة من النجوم: أنس طيارة، هيا مرعشلي، ريتا حرب، وسعد مينه.",
        "مشاركة مميزة من: ديمة الجندي، ريم خوري، رامي أحمر، وجينا أبو زيد.",
        "عمل مكون من 90 حلقة يجمع بين الطابع الاجتماعي والكوميديا الخفيفة (دراما معرّبة)."
      ],
      "items_en": [
        "Starring an elite cast: Anas Tayara, Haya Maraachli, Rita Harb, and Saad Mina.",
        "Featuring special appearances by: Dima Al Jundi, Reem Khoury, Rami Ahmar, and Gina Abou Zeid.",
        "A 90-episode series that combines social themes with light comedy (an Arabic adaptation)."
      ],
      "items_fr": [
        "Mettant en vedette un casting d'élite : Anas Tayara, Haya Maraachli, Rita Harb et Saad Mina.",
        "Avec la participation spéciale de : Dima Al Jundi, Reem Khoury, Rami Ahmar et Gina Abou Zeid.",
        "Une série de 90 épisodes qui allie thèmes sociaux et comédie légère (une adaptation arabe)."
      ]
    },
    {
      "id": "a-1",
      "type": "alert",
      "variant": "note",
      "title": "متابعة ممتعة لزوار الموقع",
      "title_en": "Enjoyable Viewing",
      "title_fr": "Bon visionnage",
      "html": "يتميز هذا العمل بإيقاع سريع وحبكة ذكية، مما يجعله وجبة درامية دسمة وممتعة للمشاهدة بدون لحظات ملل.",
      "html_en": "This series is characterized by its fast pace and clever plot, making it a rich and highly entertaining drama with no dull moments.",
      "html_fr": "Cette série se caractérise par son rythme effréné et son intrigue intelligente, ce qui en fait un drame riche et très divertissant sans aucun moment d'ennui."
    },
    {
      "id": "q-1",
      "type": "quote",
      "html": "حكاية حب بدأت كصفقة... لكن القلوب لا تعترف بالعقود.",
      "html_en": "A love story that started as a deal... but hearts do not recognize contracts.",
      "html_fr": "Une histoire d'amour qui a commencé comme un marché... mais les cœurs ne reconnaissent pas les contrats.",
      "author": "من أجواء المسلسل",
      "author_en": "From the series",
      "author_fr": "De la série"
    },
    {
      "id": "h-3",
      "type": "heading",
      "level": 3,
      "text": "هل سينتصر الحب أم الماضي المجهول؟",
      "text_en": "Will Love Prevail or the Unknown Past?",
      "text_fr": "L'amour triomphera-t-il ou le passé inconnu ?"
    },
    {
      "id": "p-3",
      "type": "paragraph",
      "collapsible": true,
      "collapseTitle": "انقر لمعرفة المزيد حول تطور الأحداث",
      "collapseTitle_en": "Click to read more about the plot development",
      "collapseTitle_fr": "Cliquez pour en savoir plus sur le déroulement de l'intrigue",
      "html": "الصراع لا يتوقف عند الاتفاق المؤقت، بل يمتد لكشف أسرار قديمة لم تكن في الحسبان. التناقض بين حياة الملياردير وبائعة الورد يخلق مفارقات اجتماعية وكوميدية ممتعة. ومع مرور الحلقات، يتضح أن التهديد الأكبر لعلاقتهما لا يأتي من الخارج، بل من ماضٍ لم يُكشف بعد.",
      "html_en": "The conflict doesn't stop at the temporary agreement; it extends to reveal unexpected old secrets. The stark contrast between the billionaire's life and the flower seller creates delightful social and comedic ironies. As the episodes progress, it becomes clear that the biggest threat to their relationship comes not from the outside, but from an unrevealed past.",
      "html_fr": "Le conflit ne s'arrête pas à l'accord temporaire ; il s'étend pour révéler de vieux secrets inattendus. Le contraste saisissant entre la vie du milliardaire et celle de la fleuriste crée de délicieuses ironies sociales et comiques. Au fil des épisodes, il devient clair que la plus grande menace pour leur relation ne vient pas de l'extérieur, mais d'un passé inavoué."
    },
    {
      "id": "a-2",
      "type": "alert",
      "variant": "warning",
      "title": "تنبيه للمشاهدين",
      "title_en": "Viewer Alert",
      "title_fr": "Avis aux spectateurs",
      "html": "تأكد من متابعة التفاصيل الصغيرة في الحلقات الأولى، فكل شخصية تخفي سراً قد يقلب الموازين في الحلقات الختامية!",
      "html_en": "Make sure to pay attention to the small details in the early episodes, as every character hides a secret that could turn the tables in the finale!",
      "html_fr": "Assurez-vous de prêter attention aux petits détails dans les premiers épisodes, car chaque personnage cache un secret qui pourrait renverser la situation dans le final !"
    }
  ]
}